import { combineReducers } from "redux";
import { IAction } from "../actions";
import apiCallInProgress from "./api-status.reducer";

import { initialState, IState } from "./index";
import offerLetterReducer from "./offer-letter.reducer";

const appReducer = combineReducers({
  apiCallInProgress,
  offerLetterLoginDetails: offerLetterReducer,
});

export const rootReducer = (
  state: IState = initialState,
  action: IAction<string, IState>
) => {
  switch (action.type) {
    default:
      return appReducer(state, action);
  }
};
